<script setup>
import NodeIconButton from './NodeIconButton.vue';

defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
  deleteTitle: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['delete']);
</script>

<template>
  <div
    class="absolute -left-2 -top-2 z-30 opacity-0 transition duration-150 group-hover:opacity-100"
    :class="isVisible ? 'opacity-100' : ''"
  >
    <NodeIconButton
      icon="i-lucide-x"
      variant="floatingDanger"
      size="sm"
      :title="deleteTitle"
      @click.stop="emit('delete')"
    />
  </div>
</template>
